import { ActionIcon } from "PFComponents/action_icon";
import { Flex } from "PFComponents/containers";
import { Tooltip, TooltipIcon } from "PFComponents/tooltip";

import { ContactInfo } from "../use_contact_info_array";

type ContactIconProps = ContactInfo;

export const ContactIcon = ({ value, url, target, iconName, title, onClick }: ContactIconProps) => {
  if (url) {
    return (
      <Tooltip<HTMLDivElement> content={value}>
        {({ ref, getReferenceProps }) => (
          <Flex ref={ref} {...getReferenceProps()} alignItems="center">
            <ActionIcon
              {...getReferenceProps()}
              tag="a"
              href={url}
              target={target}
              rel="noopener noreferrer"
              name={iconName}
              size="sm"
              color="paletteBlue0"
              title={title}
            />
          </Flex>
        )}
      </Tooltip>
    );
  }

  return (
    <TooltipIcon
      content={value}
      iconName={iconName}
      onClick={onClick}
      iconProps={{
        size: "sm",
        color: "paletteBlue0",
        title
      }}
    />
  );
};
